import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../constant/Constant';

const BASE = 'error';
const HANDLE_SHOW = BASE + PATH_DELIMITER + 'HANDLE_SHOW';
const HANDLE_CLOSE = BASE + PATH_DELIMITER + 'HANDLE_CLOSE';

export const handleShow = createAction(HANDLE_SHOW);
export const handleClose = createAction(HANDLE_CLOSE);

const initialState = {
    open: false,
    message: '',
    goPage: '',
};

const module = handleActions(
    {
        [HANDLE_SHOW]: (state, { payload: { message, goPage } }) => ({ ...state, open: true, message, goPage }),
        [HANDLE_CLOSE]: (state) => ({ ...state, open: false, message: '' }),
    },
    initialState,
);

export default module;
